import axios from 'axios'

// Session invalidée par l'engine : retour au login avec un message
// - révoquée (reset de la double authentification par un admin) : 401 session_revoked
// - expirée (ex. connexion « en tant que » au-delà de sa durée, token illisible) : l'engine ne reconnaît plus le token
//   → 403 user_should_be_connected sur les routes, 422 missing_id_or_token sur /users/me
const SESSION_REVOKED = 'dash.error.session_revoked'
const NOT_CONNECTED = 'dash.error.user_should_be_connected'
const MISSING_TOKEN = 'dash.error.missing_id_or_token'
let redirecting = false

function logout(reason) {
  if (redirecting) return
  redirecting = true
  try {
    if (window.$crisp) window.$crisp.push(['do', 'session:reset'])
  } catch (e) { /* Crisp absent */ }
  localStorage.clear()
  localStorage.setItem(reason, '1')
  location.href = '/'
}

const isRevoked = (status, body) => status === 401 && body && body.error === SESSION_REVOKED

// Seulement si la requête portait un token : une page publique sans session n'est pas concernée
function isExpired(status, body, hadToken) {
  if (!hadToken || !body) return false
  const exception = body.reason && body.reason.exception
  if (status === 403 && exception === NOT_CONNECTED) return true
  return status === 422 && body.error === MISSING_TOKEN
}

const bearer = value => /^Bearer\s+\S+/.test(String(value || '')) && !/^Bearer\s+(null|undefined)$/.test(String(value))

function handle(status, body, hadToken) {
  if (isRevoked(status, body)) logout('session_revoked')
  else if (isExpired(status, body, hadToken)) logout('session_expired')
}

export default {
  install(Vue) {
    Vue.http.interceptors.push((request, next) => {
      const hadToken = bearer(request.headers && request.headers.get && request.headers.get('Authorization'))
      next(response => handle(response.status, response.body, hadToken))
    })
    axios.interceptors.response.use(
      response => response,
      error => {
        const res = error && error.response
        if (res) {
          const headers = (error.config && error.config.headers) || {}
          handle(res.status, res.data, bearer(headers.Authorization || headers.authorization))
        }
        return Promise.reject(error)
      }
    )
  }
}
